/**
 * Picks v2 or v1 of the per-session Captions Editor page based on
 * the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CaptionsEditorPage   from './CaptionsEditorPage';
import CaptionsEditorPageV2 from './CaptionsEditorPageV2';

export default function CaptionsEditorPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CaptionsEditorPageV2 : CaptionsEditorPage;
  return <Component {...props} />;
}
